import { PageType, PageTypes } from 'strapi/page/types';
import { RequestParams } from 'strapi/types';

import { HeroSectionStrapiComponent } from './types';

export const heroSectionParams: (
  type: PageType
) => RequestParams<PageTypes & { heroSection: HeroSectionStrapiComponent }> = (
  _: PageType
) => ({
  populate: {
    heroSection: {
      populate: {
        buttons: true,
        image: true,
      },
    },
  },
});
